let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7PL1Y")).then(() => parcelRequire('79Syx'));